// Keep Shopify's product-specific checkout and PayPal session creation intact.
if (!window.seoulPdpPaymentsInitialized) {
  window.seoulPdpPaymentsInitialized = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.seoul-pdp-payments [data-direct-checkout]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();
    const form = button.form;
    if (!form || !form.reportValidity()) return;

    const payments = button.closest('.seoul-pdp-payments');
    const checkoutLink = payments.querySelector('more-payment-options-link a');
    if (checkoutLink && customElements.get('more-payment-options-link')) {
      if (checkoutLink.getAttribute('aria-disabled') !== 'true') checkoutLink.click();
      return;
    }

    // When Shopify doesn't recommend a wallet, use its standard product form.
    // Native submission preserves variant, quantity, selling plan and properties.
    const returnTo = document.createElement('input');
    returnTo.type = 'hidden';
    returnTo.name = 'return_to';
    returnTo.value = '/checkout';
    form.append(returnTo);
    HTMLFormElement.prototype.submit.call(form);
    returnTo.remove();
  });
}
